module.exports = __webpack_public_path__ + "static/img/6.b41b311.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/sp/6.png
// module id = h4Vc
// module chunks = 0